import React from 'react'
import { HeaderPageSpacer } from '../Header/HeaderPageSpacer'
import style from './style.module.scss'

// Shown while a page's code is still downloading. Without it the route area is empty
// and the footer renders directly under the header.
export const PageSkeleton = () => (
  <div className={style.page} role="status" aria-busy="true">
    <span className={style.srOnly}>Loading page</span>
    <HeaderPageSpacer />
    <div className={style.column} aria-hidden="true">
      <div className={`${style.bar} ${style.heading}`} />
      <div className={`${style.bar} ${style.line}`} />
      <div className={`${style.bar} ${style.lineShort}`} />
      <div className={`${style.bar} ${style.block}`} />
    </div>
  </div>
)
